export enum SpaceOfRoom {
  // ONLY FOR MAIN ROOMS
  moreThan10m = 'moreThan10m',
  between41And75m = 'between41And75m',
  moreThan76m = 'moreThan76m',
  // FOR VERANDA
  Aucune = 'None',
  lessThan10 = '_0_10m2',
  between10And40 = '_10_40m2',
  moreThan40 = '_40m2',
}
